module.exports = __webpack_public_path__ + "img/project-edu-08.5991adb0.png";